import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-development',
  templateUrl: './app-development.component.html',
  styleUrls: ['./app-development.component.scss']
})
export class AppDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
